import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'
import FeaturedMatch from 'components/FeaturedMatch'
import { Match, MatchStatus, Team, Jersey } from 'protos'

const exampleMatch = Match.create({
  homeTeam: Team.create({
    name: 'Home team',
    jersey: Jersey.create({
      baseColor: '000000',
      sleeveColor: 'cccccc',
      numberColor: 'ffffff'
    })
  }),
  awayTeam: Team.create({
    name: 'Away team',
    jersey: Jersey.create({
      baseColor: 'f9f9f9',
      sleeveColor: 'cccccc',
      numberColor: 'ffffff'
    })
  }),
  status: MatchStatus.MS_UPCOMING,
  kickoff: new Date().getTime() / 1000 + 3600,
  kickoffRemainingSec: 3600,
})

storiesOf('FeaturedMatch', module)
  .add('default', () => (
    <FeaturedMatch match={exampleMatch} />
  ))
  .add('jersey sizes', () => (
    <>
      <FeaturedMatch match={exampleMatch} jerseySize="xsmall" />
      <FeaturedMatch match={exampleMatch} jerseySize="small" />
      <FeaturedMatch match={exampleMatch} jerseySize="medium" />
      <FeaturedMatch match={exampleMatch} jerseySize="large" />
      <FeaturedMatch match={exampleMatch} jerseySize="xlarge" />
    </>
  ))
  .add('in a grid', () => (
    <Grid container>
      <Grid item xs={12} md={6}>
        <FeaturedMatch match={exampleMatch} />
      </Grid>
      <Grid item xs={12} md={6}>
        <FeaturedMatch match={exampleMatch} />
      </Grid>
      <Grid item xs={12} md={6}>
        <FeaturedMatch match={exampleMatch} />
      </Grid>
      <Grid item xs={12} md={6}>
        <FeaturedMatch match={exampleMatch} />
      </Grid>
      <Grid item xs={12} md={6}>
        <FeaturedMatch match={exampleMatch} />
      </Grid>
    </Grid>
  ))
